import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { Icon } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const SomethingWentWrong: React.FC = (props) => {
  return (
    <Grid container className={cssExports.somethingWentWrongContainer} justifyContent="center" alignContent="center">
      <Grid container className={cssExports.errorContent} direction="column">
        <Grid item>
          <Icon icon={IconDefinitionConstants.WExclamationTriangle} displayType={StyleEnums.DisplayType.Info} />
        </Grid>
        <Grid item className={cssExports.title}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Errors.SomethingWentWrong)}
        </Grid>
        <Grid item>{LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Errors.ErrorBoundaryMessage)}</Grid>
        <Grid item className={cssExports.bottomText}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Errors.ErrorBoundaryFooterMessage)}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SomethingWentWrong;
